import UsersListV2 from './UsersListV2';

const users = {
    list: UsersListV2,
};

export default users;
